export default __webpack_public_path__ + "static/media/third-party-data-consent-kr-1.988871ef.jpg";